<template><div></div></template>
<script>

export default {
  computed: {
    activeLivingOption () {
      return this.$store.getters['property/activeLivingOption']
    }
  },

  // watch: {
  //   activeLivingOption: {
  //     handler (livingOption) {
  //       // if (livingOption.subsections.length === 1) {
  //       //   const params = this.$route.params
  //       //   this.$router.push(`/category/${params.categoryId}/live/${params.pathway}/${params.livingOptionId}/subsection/${livingOption.subsections[0]._id}`)
  //       // }
  //     },
  //     immediate: true
  //   }
  // }
}
</script>